<template>
  <div class="environmental">
    <div class="environmental__bg-video-wrapper">
      <video
        class="environmental__bg-video"
        ref="video"
        :src="bgVideo"
        muted
        plays-inline
        autoplay
      ></video>
    </div>
    <div class="environmental__innerwrap">
      <h1 class="environmental__title" v-html="benefit.title"></h1>
      <div class="environmental__content">
        <ul>
          <li v-for="(item, index) in benefit.list" :key="index" v-html="item"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Environmental',
  props: ['benefit', 'active'],
  computed: {
    bgVideo() {
      return `static/${this.benefit.bg_video}`;
    },
  },
  data() {
    return {
      videoPlayed: false,
    };
  },
  mounted() {
    if (!this.active) {
      this.$refs.video.pause();
    } else {
      this.videoPlayed = true;
    }
  },
  watch: {
    active(newActive) {
      if (newActive === true && !this.videoPlayed) {
        this.videoPlayed = true;
        setTimeout(() => {
          this.$refs.video.play();
        }, 500);
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/helpers';

.environmental {
  @include section;
  // background: $c_black;
  color: $c_white;
  position: relative;

  &__innerwrap {
    // width: 10/12 * 100%;
  }

  &__bg-video-wrapper {
    background: $c_black;
    @include aspect-ratio-box-cover(1024/708, $menubar-height);
    z-index: -1;
  }

  &__bg-video {
    width: 100%;
    height: 100%;
    display: block;
  }

  &__title {
    width: calc(8/12 * 100%);
    @include font-heading;
    position: relative;

    &::before {
      content: '';
      display: block;
      width: 363px;
      height: 319px;
      position: absolute;
      top: -20px;
      // left: calc(100% - 90px);
      right: -220px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('../../assets/environmental_leaf.svg');
    }
  }

  &__content {
    width: calc(5/12 * 100%);
    @include font-content;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Environmental.vue